"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeIcons = void 0;
var font_icons_mdl2_1 = require("@fluentui/font-icons-mdl2");
Object.defineProperty(exports, "initializeIcons", { enumerable: true, get: function () { return font_icons_mdl2_1.initializeIcons; } });
//# sourceMappingURL=Icons.js.map